import React, { FC, useEffect } from "react";
import { useForm } from "react-final-form";
import { IWizardStepContent } from "../../../../wizard/types";
import { DurationUnit } from "../../../../../types";
import {
  AccommodationFees,
  Calculation,
  OtherFees,
  Price,
} from "../../components";
import { CourseHousingType } from "../../../types";

const Content: FC<IWizardStepContent> = ({ stepName, values }) => {
  const { change } = useForm();

  const currency = values?.[stepName]?.currency?.name;
  const priceDurationUnit = values?.[stepName]?.priceDurationUnit?.id;
  const housingTypes = values?.step2?.housingTypes || [];
  const residenceRequired = housingTypes.includes(CourseHousingType.RESIDENCE);
  const homestayRequired = housingTypes.includes(CourseHousingType.HOMESTAY);

  useEffect(() => {
    if (!residenceRequired) {
      change(`${stepName}.boardingAmount`, null);
    }
  }, [residenceRequired]);

  useEffect(() => {
    if (!homestayRequired) {
      change(`${stepName}.homestayAmount`, null);
    }
  }, [homestayRequired]);

  useEffect(() => {
    if (priceDurationUnit === DurationUnit.FULL) {
      change(`${stepName}.priceDurationAmount`, null);
    }
  }, [priceDurationUnit]);

  useEffect(() => {
    if (priceDurationUnit === DurationUnit.FULL) {
      change(`${stepName}.priceDurationAmount`, null);
    }
  }, [priceDurationUnit]);

  return (
    <>
      <Price
        fieldsGroupName={stepName}
        currency={currency}
        durationAmountRequired={priceDurationUnit !== DurationUnit.FULL}
      />
      <AccommodationFees
        fieldsGroupName={stepName}
        residenceRequired={residenceRequired}
        homestayRequired={homestayRequired}
      />
      <OtherFees
        fieldsGroupName={stepName}
        currency={currency}
        infoText={"You need to indicate every fee separately"}
      />
      <Calculation
        fieldsGroupName={stepName}
        currency={currency}
        values={values}
      />
    </>
  );
};

export default Content;
